import common from './common.json'
import course from './course.json'
import errorMessage from './error_message.json'
import menu from './menu.json'
import auth from './auth.json'
import weekly from './weekly.json'
import setting from './setting.json'
import dashboard from './dashboard.json'
import userList from './user_list.json'

export default {
  common,
  course,
  error_message: errorMessage,
  menu,
  auth,
  weekly,
  setting,
  dashboard,
  userList
}
